import notEqual from "ramda-extension/es/notEqual";
export const isNotUndefinedString = notEqual('undefined');
export const concatOpenidScope = (input = '')=>(input.includes('openid') ? input : `openid ${input}`).trim();
export const jsonParseOrEmptyObject = (state)=>{
    try {
        return JSON.parse(state);
    } catch (_e) {
        return {};
    }
};
export const getLocationPersistenceStateString = (locationSearchState)=>({ pathname, hash, search })=>{
        const searchParams = new URLSearchParams(search);
        if (locationSearchState) searchParams.set('state', locationSearchState);
        return JSON.stringify({
            pathname,
            hash,
            search: searchParams.toString(),
            originatedFromApp: true
        });
    };
